/**
 * API URL helpers for ai-tutor + gateway integration.
 *
 * wsUrl() returns a WebSocket URL pointing at the canvas gateway.
 */

import { CANVAS_GATEWAY_BASE_URL } from "../flags";

/** Returns a WebSocket URL on the canvas gateway (e.g. ws://localhost:3010/canvas/ws). */
export function wsUrl(path: string): string {
  const base = CANVAS_GATEWAY_BASE_URL.replace(/^http/, "ws");
  return `${base}${path}`;
}
